/**
 * These are the fields used when selecting a group
 * of fields in the CSV export dialog.
 */
enum CsvExportGroupFieldName {
  BASIC_PROFILE = 'basic-profile',
  HOUSEHOLD_INFORMATION = 'household-information',
}

export default CsvExportGroupFieldName;
